export default __webpack_public_path__ + "static/media/Glass_icon_green.39617073.svg";